import { jsx, jsxs } from "@ecopages/jsx/jsx-runtime";
import { cx } from "@/lib/cx";
import "./disclosure-group.script";
import "./disclosure.script";
export function RuiDisclosureIcon({
  variant = "chevron",
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("span", {
    ...props,
    class: cx("rui-disclosure__icon", `rui-disclosure__icon--${variant}`, className),
    "data-disclosure-icon": true,
    "aria-hidden": "true"
  });
}
export function RuiDisclosureTrigger({
  children,
  class: className,
  disabled,
  icon,
  iconPosition = "start",
  ...props
}) {
  const showIcon = icon !== null;
  const iconNode = showIcon ? icon ?? /* @__PURE__ */jsx(RuiDisclosureIcon, {}) : null;
  return /* @__PURE__ */jsxs("button", {
    ...props,
    type: "button",
    "data-disclosure-trigger": true,
    class: cx("rui-disclosure__trigger", iconPosition === "end" && "rui-disclosure__trigger--icon-end", className),
    disabled,
    children: [iconPosition === "start" ? iconNode : null, /* @__PURE__ */jsx("span", {
      class: "rui-disclosure__label",
      children
    }), iconPosition === "end" ? iconNode : null]
  });
}
export function RuiDisclosurePanel({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    "data-disclosure-panel": true,
    "data-ref": "panel",
    class: cx("rui-disclosure__panel", className),
    children: /* @__PURE__ */jsx("div", {
      class: "rui-disclosure__panel-inner",
      children
    })
  });
}
function DisclosureShell({
  children
}) {
  return /* @__PURE__ */jsx("div", {
    class: "rui-disclosure",
    "data-ref": "root",
    children
  });
}
export function RuiDisclosure({
  trigger,
  children,
  ...props
}) {
  if (trigger != null) {
    return /* @__PURE__ */jsx("rui-disclosure", {
      ...props,
      children: /* @__PURE__ */jsxs(DisclosureShell, {
        children: [/* @__PURE__ */jsx(RuiDisclosureTrigger, {
          children: trigger
        }), children != null ? /* @__PURE__ */jsx(RuiDisclosurePanel, {
          children
        }) : null]
      })
    });
  }
  return /* @__PURE__ */jsx("rui-disclosure", {
    ...props,
    children: /* @__PURE__ */jsx(DisclosureShell, {
      children
    })
  });
}
export function RuiDisclosureGroup({
  children,
  ...props
}) {
  return /* @__PURE__ */jsx("rui-disclosure-group", {
    ...props,
    children: /* @__PURE__ */jsx("div", {
      class: "rui-disclosure-group",
      "data-ref": "root",
      children
    })
  });
}